import React from 'react'
import PropTypes from 'prop-types'
import BackLink from '@app/components/ui/buttons/BackLink'
import AnswerPresenter from '@app/components/Player/AnswerPresenter'
import Api from '@app/api'
import _ from 'lodash'

const Answer = ({ route, global: { olympiads } }) => {
  const { match: { params: { olympiad_id, id } } } = route
  const olympiad = _.find(olympiads, _.matchesProperty('id', olympiad_id))

  let task = _.find(olympiad.mainCards, _.matchesProperty('id', id))
  if (!task) { return null }

  return (
    <div className="page teacher-tasks-page">
      <div className="plate-headbar">
        <BackLink to="/teachers/tasks" />
        <h1 className="plate-heading plate-heading--left">
          { task.name }
        </h1>
      </div>
      <div className="plate plate--xxl mt-0">
        <AnswerPresenter
          className="text-center mb-2"
          url={Api.teachers.answer({ olympiad_id: olympiad_id, id }).correct.path}
        />
      </div>
    </div>
  )
}

Answer.propTypes = {
  route: PropTypes.object.isRequired
}

export default Answer
